/* Core & libraries */
import React, { useEffect, useState } from "react";

/* Helpers, constants, custom methods, internal libraries */
import { useAirlineProgramsService } from "../../services/airlineProgramsService.js";
import { PAGE_TITLES } from "../../constants/appConstants";
import { useAnalytics } from "../../hooks/useAnalytics";

/* Components */
import UAProgramHeader from "../../components/uaProgramHeader";
import UAProgramContent from "../../components/uaProgramContent";
/* Styles */

const ProgramUA = () => {

    const { getAirlineProgramsData, delinkUnitedAirlines, airlineProgramsData, joinUnitedAirlines } = useAirlineProgramsService();
    const { initAnalytics } = useAnalytics();
    const [unitedAirlinesSupplier, setUnitedAirlinesSupplier] = useState({});

    useEffect(() => {
        (async () => {
            await getAirlineProgramsData()
        })();
        const initUtagData = {
            channel: 'content',
            pageName: PAGE_TITLES["unitedAirlines"]
        };
        initAnalytics(initUtagData, 'init call', 'view')
    }, []);

    useEffect(() => {
        setUnitedAirlinesSupplier(airlineProgramsData?.suppliers?.filter(
            supplier => supplier.providerName === "United Airlines"
        )[0])
    }, [airlineProgramsData]);

    return (
        <div className="program-page">
            <UAProgramHeader airlineProgramsData={airlineProgramsData}/>
            <UAProgramContent
                delinkUnitedAirlines={delinkUnitedAirlines} 
                unitedAirlinesSupplier={unitedAirlinesSupplier} 
                joinUnitedAirlines={joinUnitedAirlines}
            />
        </div>
    )
}

export default ProgramUA;
